// Die zwei Rueckmeldungen der KI-Zusammenfassung: „KI ist deaktiviert" (503)
// und die Zusammenfassung selbst mit Kopier-Knopf und Egress-Hinweis.
//
// WOFUER: nur herausgeloest, damit `routes/Project.tsx` unter 500 Zeilen
// bleibt. Inhalt, `data-testid`s und Texte sind unveraendert — die
// Bestandstests in `Project.aiSummary.test.tsx` greifen weiter.

import type { JSX } from "preact";

export interface ProjectAiSummaryProps {
  /** Der Anbieter hat mit 503 geantwortet (KI serverseitig abgeschaltet). */
  unavailable: boolean;
  summary: string | null;
}

export function ProjectAiSummary(props: ProjectAiSummaryProps): JSX.Element {
  const { unavailable, summary } = props;
  return (
    <>
      {unavailable && (
        <p
          class="mb-4 rounded border border-[color:var(--color-outline-variant)] bg-[color:var(--color-surface-container-low)] px-3 py-2 text-xs italic text-[color:var(--color-on-surface-variant)]"
          data-testid="ai-summary-503"
        >
          KI ist derzeit deaktiviert.
        </p>
      )}
      {summary && (
        <section
          class="mb-4 rounded border border-[color:var(--color-outline-variant)] bg-[color:var(--color-surface-container-low)] px-4 py-3"
          data-testid="ai-summary-panel"
        >
          <p
            class="whitespace-pre-wrap text-sm text-[color:var(--color-on-surface)]"
            data-testid="ai-summary-text"
          >
            {summary}
          </p>
          <button
            type="button"
            onClick={() => void navigator.clipboard.writeText(summary)}
            class="mt-2 rounded border border-[color:var(--color-outline-variant)] px-2 py-1 text-label font-medium text-[color:var(--color-on-surface-variant)] transition-colors hover:bg-[color:var(--color-surface-container)]"
            aria-label="Zusammenfassung in die Zwischenablage kopieren"
          >
            Kopieren
          </button>
          <p
            class="mt-2 text-label text-[color:var(--color-on-surface-variant)]"
            data-testid="ai-egress-notice"
          >
            Aufgabentitel, Beschreibungen und Kommentare wurden an den KI-Anbieter gesendet.
          </p>
        </section>
      )}
    </>
  );
}
